<template>
  <van-popup v-model="visible" position="bottom" @input="handleVisibleChange">
    <div class="popup-agreement-container">
      <div class="title">
        <i></i>请勿接听任何<span class="ctip">境外来电!</span>
      </div>
      <div class="tip-msg">
        任何放款前以缴纳保证金、利息等名义的行为均为
        <span class="ctip">诈骗!</span> 任何要求您提供银行卡
        密码、验证码等个人信息均为 <span class="ctip">诈骗!</span>
        <i></i>
      </div>
      <div class="content-box">
        <h6>{{ title }}</h6>
        <div class="content-txt-box">
          <van-skeleton title :row="6" :loading="loading">
            <div v-html="html"></div>
          </van-skeleton>
        </div>
      </div>
      <div class="footer-box">
        <van-button class="btn-apply" @click="handleAgree">
          同意协议，继续申请
        </van-button>
      </div>
    </div>
  </van-popup>
</template>

<script>
import { getAgreement } from "../api";
import { Base64 } from "js-base64";
export default {
  name: "AgreementPopup",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    user:{
      type:Object,
      default: () => ({})
    },
    title: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      visible: this.value,
      html: "",
      loading: false,
    };
  },
  watch: {
    value(newVal) {
      this.visible = newVal;
      if (newVal) {
        this.html = ''
        this.loadingAgreementDetail((res) => {
          if (res.code == 1 && res.details) {
          }
        })
      }
    },
    type(newVal) {
    },
    user:{
      immediate: true,
      deep: true,
      handler(newVal) {
      },
    }
  },
  methods: {
    handleVisibleChange(visible) {
      this.$emit("input", visible);
    },
    handleAgree() {
      this.$emit("agree");
      this.handleVisibleChange(false);
    },
    loadingAgreementDetail() {
      if (this.type) {
        this.loading=true
        getAgreement(this.type,this.user).then(res => {
           this.loading=false
          var txt = res.data.details;
          this.html = Base64.decode(txt)//decodeURIComponent()
        }).catch(err => {
          this.loading=false
        });
      }
    }
  },
};
</script>

<style lang="less" scoped>
.popup-agreement-container {
  position: relative;
  max-height: 90vh;
  overflow: auto;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  background: linear-gradient(180deg, #daf2ff 0%, #eef9ff 54%);
  padding: 16px;

  .title {
    display: flex;
    color: #2e517b;
    font-size: 16px;
    font-weight: 700;
    margin-bottom: 10px;
    align-items: center;
    justify-content: center;

    i {
      display: inline-block;
      width: 16px;
      height: 16px;
      background-image: url("/images/icon-samll-warning.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      margin-right: 6px;
    }
  }

  .ctip {
    color: #ff6b00;
    font-weight: 700;
  }

  .tip-msg {
    color: rgba(0, 0, 0, 0.6);
    text-align: justify;
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: 21px;
    padding: 0 16px;
    position: relative;
    z-index: 2;

    i {
      position: absolute;
      top: -18px;
      left: 50%;
      transform: translate(-50%, 0);
      width: 88px;
      height: 88px;
      background: url("/images/icon-warining.png") no-repeat center/cover;
      z-index: -2;
    }
  }

  .content-box {
    margin-top: 16px;
    background: #b9ddf2;
    border-radius: 16px 16px 16px 16px;
    border: 4px solid #b9ddf2;
    position: relative;


    h6 {
      text-align: center;
      padding: 14px 0;
      color: #254774;
      font-size: 16px;
      font-weight: 500;
    }

    .content-txt-box {
      color: rgba(0, 0, 0, 0.6);
      text-align: justify;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 18px;
      background: linear-gradient(180deg, #daf2ff 0%, #eef9ff 54%);
      border-radius: 14px 14px 14px 14px;
      border: 2px solid #b9ddf2;
      padding: 8px;
      max-height: 300px;
      overflow: hidden;
      overflow-y: auto;

      p {
        margin-bottom: 20px;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }

  .footer-box {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px 0;
    padding-bottom: 20px;

    button {
      width: 327px;
    }
  }
}

.btn-apply {
  margin-top: 10px;
  border-radius: 25px;
  width: 300px;
  height: 50px;
  flex-shrink: 0;
  border: 1px solid #cdedff;
  background: linear-gradient(90deg, #4d9bff 0%, #67d1ff 100%);
  box-shadow: 0 4px 4px 0 rgba(3, 92, 242, 0.12);
  color: #fff;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 21px;

  &:disabled {
    background: #cccccc;
    border: 1px solid #cccccc;
    box-shadow: none;
    cursor: not-allowed;
    color: #999999;
  }
}
</style>